import React from "react";
import "./index.css";
import { BookShape, CertificateCard } from "../../../component";
import VideoIcon from "../../../assets/images/videoIcon.svg";
import Html from "../../../assets/images/html.svg";
import Css from "../../../assets/images/css.svg";
import Js from "../../../assets/images/javascript.svg";
import github from "../../../assets/images/github.svg";
import firebase from "../../../assets/images/friebase.svg";
import es6 from "../../../assets/images/es6.svg";
import reactLogo from "../../../assets/images/react.svg";
import Textdivcomp from "./Textdivcomp";

const OurServices = () => {
  return (
    <div className="OurServices">
      <div
        className="our-services-book-card-comp" style={styles.ContentsDiv}>
        <Textdivcomp
          btnimg={VideoIcon}
          btntext={"More Tutorial"}
          Heading={"Tutorials to guide you beyond"}
          top={100}
          data_aos='fade-right'
        />
        <div
          data-aos="fade-left"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
          // data-aos-easing="ease-in-out"
          // data-aos-mirror="true"
          // data-aos-once="false"
          // data-aos-anchor-placement="top-center"
          style={styles.BookShapDiv} className="Book-Shape-Div">
          <BookShape
            icons={[Html, Css, Js]}
            name={"Website development using"}
            description={
              "HTML, CSS & JS combine the building blocks of structure and style to create dynamic & engaging websites."
            }
          />
          <BookShape
            icons={[github, firebase, es6, reactLogo]}
            name={"Web, Android and iOS Development using"}
            description={
              "Android and iOS applications using React provide a streamlined approach to cross-platform development."
            }
          />
        </div>
      </div>

      <div className="multipleLines"></div>
      <div

        style={styles.ContentsDiv2} className="our-services-Cirtificate-div">
        <div
          data-aos="fade-right"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          className="Certificated-div">
          <CertificateCard />
        </div>
        <div
          data-aos="fade-left"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          className="OurServicesTxtDiv">
          <Textdivcomp
            btnimg={VideoIcon}
            btntext={"More Tutorial"}
            Heading={"Get certificates"}
            body={"Earn a certificate for every course you complete and showcase your new skills to future employers."}
            colors={"black"}
            className={"Cirtificate-txt-card"}
          />
        </div>
      </div>
    </div>
  );
};
export default OurServices;
const styles = {
  ContentsDiv: {
    flexWrap: "wrap",
    display: "flex",
    width: "100%",
    minHeight: 600,
    alignItems: "center",
    justifyContent: "space-around",
  },
  ContentsDiv2: {
    flexWrap: "wrap",
    display: "flex",
    width: "100%",

    alignItems: "start",
    justifyContent: "space-around",
  },
  Text_div: { display: "flex", flexDirection: "column", maxWidth: 400 },
  Heading: {
    fontFamily: "Poppins",
    fontSize: 17,
    margin: 0,
  },
  subHeading: { fontSize: 40, fontWeight: "bold", margin: 0 },
  BookShapDiv: {
    display: "flex",
    flexWrap: "wrap",
    top: 120,
    position: "relative",
  },
};
